<template>
  <v-dialog v-model="dialogShow" persistent max-width="800">
    <v-card>
      <v-card-title style="font-weight:bold;">
        温馨提示
        <v-spacer></v-spacer>
        <p @click="hideDialog" style="font-size:14px;color:#A6A6A6;cursor:pointer;" class="iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text style="padding:30px 50px 70px 50px;">

        <div v-show="errorStatus === 3">
          <p style="line-height:33px;font-size:18px;color:#000000;">创作内容“{{creationTitle}}”违反了创作规范，未能通过审核。</p>
          <p style="line-height:33px;font-size:18px;color:#000000;" class="mb-6">您对该内容进行编辑后可重新投稿提交审核。</p>
        </div>

        <div v-show="errorStatus === 4">
          <p style="line-height:33px;font-size:18px;color:#000000;">创作内容“{{creationTitle}}”违反了创作规范，收到多方用户举报，现做下架处理。</p>
          <p style="line-height:33px;font-size:18px;color:#000000;" class="mb-6">您对该内容进行编辑后可重新投稿提交审核。</p>
          <p style="line-height:33px;font-size:18px;color:#000000;">请您认真遵守平台规范，共同营造良好的平台氛围。</p>
        </div>

        <p style="line-height:33px;font-size:18px;color:#000000;">创作规范详见<span @click="intoCharmingEarthRulePage" style="color:#1976D2;cursor:pointer;">《吉林一号·共生地球创作中心创作规范》</span></p>
        <p style="margin-top:100px;text-align:right;line-height:33px;font-size:18px;color:#000000;" class="mb-6">吉林一号·共生地球创作中心</p>
        <div style="margin-top:67px;display:flex;justify-content:center;">
          <v-btn @click="hideDialog" width="100" height="35" dark color="#1E3A8A">确认</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ErrorCreationDialog",
  //errorStatus：3未通过，4已下架
  props:["dialogShow","errorStatus","creationTitle"],
  methods:{
    intoCharmingEarthRulePage(){
      let path = this.$router.resolve({
        path: '/documentPage',query:{
          pageType:"createAgreement"
        }
      })
      window.open(path.href,'_blank')
    },
    hideDialog(){
      this.$emit("hideErrorCreationDialog")
    }
  }
}
</script>

<style scoped>

</style>